import { MODULES_REQUEST_STATUS } from '@utils/types/RequestedDashboards';
import { ComponentType, CSSProperties, ReactElement } from 'react';
import { type Banner } from '@api/banner';

export interface SideNavSubOptions {
  label: string;
  path: string;
  type?: string;
}

export enum SidebarGroupType {
  DATA_CONNECTION = 'DATA_CONNECTION',
  UA_FINANCING = 'UA_FINANCING',
  DATA_INTELLIGENCE = 'DATA_INTELLIGENCE',
  SALES_ORIGINATION = 'SALES_ORIGINATION',
  PVX_CAPITAL = 'PVX_CAPITAL',
  PVX_CONSUMER_GROWTH_FUND = 'PVX_CONSUMER_GROWTH_FUND',
  ADMINISTRATOR = 'ADMINISTRATOR',
}

export interface SideNavOptions {
  label: string;
  path: string;
  icon?: ReactElement | undefined | string;
  metadata?: Record<string, string>;
  subOptions?: SideNavSubOptions[];
  requestStatus?: MODULES_REQUEST_STATUS;
}

export interface SideNavProps {
  customWidth: string;
  options: SideNavOptions[];
  isLoading: boolean;
  isAdmin: boolean;
  username: string;
  onClickLogout?: () => void;
}

/* Navigation tree rendered by the desktop and mobile navbars: always group > module > submodule */

export interface NavSubmodule {
  type: string;
  label: string;
  href: string;
  // Passed to isCurrentRoute: an array matches the last URL segment, a string matches the path
  match: string | string[];
  // Backend module the submodule came from; keeps ungrouped submodules under their module
  moduleLabel: string;
}

export interface NavModule {
  key: string;
  nested: boolean;
  label: string;
  submodules: NavSubmodule[];
}

export type NavGroupIcon = ComponentType<{ style?: CSSProperties }>;

export interface NavGroup {
  key: SidebarGroupType;
  label: string;
  icon: NavGroupIcon;
  modules: NavModule[];
}

export interface NavTree {
  groups: NavGroup[];
  // Shown below the groups at the top level
  ungroupedModules: NavModule[];
}

export interface NavBarProps {
  navGroups: NavGroup[];
  ungroupedModules: NavModule[];
  openKeys: string[];
  onToggleGroup: (key: string) => void;
  onModuleClick: (module: NavModule) => boolean;
  onSubmoduleClick: (submodule: NavSubmodule) => void;
  isGroupActive: (group: NavGroup) => boolean;
  isModuleActive: (module: NavModule) => boolean;
  isSubmoduleActive: (submodule: NavSubmodule) => boolean;
  userName: string;
  customWidth: string;
  onClickLogout?: () => void;
  activeBanners?: Banner[];
}
